import { useState } from 'react';
import { ArrowLeft } from '@hungryroot/icons';
import { Paragraph, Heading, Button, Checkbox } from '@hungryroot/ramen';
import { useCancelSubreasons } from '../../hooks/useCancelSubreasons';
import pageStyles from '../page.module.css';

interface Props {
  testid?: string;
  cancelReasonId: number;
  onNext: (value?: {
    cancelReasonId: number[];
    cancelReasonText: string | null;
    cancelFreeTextHeader: string | null;
  }) => void;
  onPrev: () => void;
}

export function SecondaryReason(props: Props) {
  const { testid, onNext, onPrev, cancelReasonId } = props;
  const [value, setValue] = useState<number[]>([]);
  const [cancelFreeTextHeader, setCancelFreeTextHeader] = useState<
    string | null
  >(null);

  const { data: cancelSubreasons } = useCancelSubreasons({
    cancelReason: cancelReasonId,
  });

  const checkboxes = cancelSubreasons?.map(({ id, name, followup }) => {
    const isChecked = value.includes(id);
    return (
      <Checkbox
        key={id}
        testid={`${testid}-checkbox-${id}`}
        value={id}
        label={name}
        isChecked={isChecked}
        onChange={() => {
          if (isChecked) {
            setCancelFreeTextHeader(null);
            return setValue(value.filter((item) => item !== id));
          }
          setCancelFreeTextHeader(followup);
          return setValue([...value, id]);
        }}
      />
    );
  });

  return (
    <div data-testid={testid} className={pageStyles.container}>
      <Button
        onClick={onPrev}
        style="default"
        testid={`${testid}-prev`}
        size="medium"
        prominence="tertiary"
        icon={<ArrowLeft />}
        iconPosition="left"
        textPrimary="Back"
        className={pageStyles.back}
      />
      <div data-testid={`${testid}-text-section`} className={pageStyles.text}>
        <Heading
          variant="Hero"
          className={pageStyles.heading}
          testid={`${testid}-text-section-heading`}
        >
          Could you tell us more?
        </Heading>
        <Paragraph variant="lead" testid={`${testid}-text-section-heading`}>
          Select why you’d <b>most</b> like to cancel and continue:
        </Paragraph>
      </div>
      <div className={pageStyles.content}>
        <div className={pageStyles['content-inner']}>{checkboxes}</div>
      </div>
      <Button
        onClick={() => {
          onNext({
            cancelReasonId: value,
            cancelReasonText: null,
            cancelFreeTextHeader: cancelFreeTextHeader,
          });
        }}
        style="default"
        testid={`${testid}-next`}
        size="medium"
        prominence="secondary"
        textPrimary="Continue to Cancel"
        className={pageStyles.confirm}
      />
    </div>
  );
}
